import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import rootReducer from './app/reducers/index'

const initialState = {}

const middleware = [thunk]

let store

if (process.env.REACT_APP_ENV === 'production' || process.env.REACT_APP_ENV === 'test') {
  store = createStore(rootReducer, initialState, compose(applyMiddleware(...middleware)))
} else {
  store = createStore(
    rootReducer,
    initialState,
    compose(
      applyMiddleware(...middleware),
      // Without the Redux DevTools extension installed this expression is undefined, and compose()
      // then calls undefined as an enhancer — "Cannot read properties of undefined (reading
      // 'apply')" before a single component renders. Every dev browser without the extension
      // (incognito, a fresh profile, an automated one) got a blank page.
      (window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()) || ((f) => f)
    )
  )
}

export default store
